var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useMemo, useState } from "react";
import { useIntl } from "react-intl";
import { useOkapiKy } from "@folio/stripes/core";
import { useMutation, useQueryClient } from "react-query";
import { Button, Checkbox, Col, MessageBanner, Modal, ModalFooter, Row, Select, TextField, } from "@folio/stripes/components";
import { applyContinuousNumbering, updatePeriodicalCheckSettings, } from "../../api/periodicalCheckService";
import { extractNumberingCollisions } from "../../utils/numberingCollisions";
import { extractServerErrorMessage, readErrorCode, } from "../../utils/errorHandler";
import { isManualFrequency } from "../../utils/manualFrequencies";
import { invalidateDepositRecordViews } from "../../utils/depositRecordQueries";
import { isValidVolumeAnchor, } from "../../utils/volumeWindow";
import { PERIODICAL_LIBRARY_DETAIL_KEY } from "../../hooks/usePeriodicalLibraryActions";
import { invalidateVolumeViews } from "../../hooks/usePeriodicalVolumes";
import { useContinuousNumberingDraft } from "../../hooks/useContinuousNumberingDraft";
import { ErrorType } from "../../types/ErrorType";
import { ContinuousNumberingSection } from "./ContinuousNumberingSection";
import styles from "./PeriodicalCheckSettingsDialog.module.css";
var MIN_MONTHS = 1;
var MAX_MONTHS = 120;
var DEFAULT_MONTHS_HINT = 6;
var MONTHS = Array.from({ length: 12 }, function (_, index) { return index + 1; });
var PeriodicalCheckSettingsDialogBody = function (_a) {
    var _b, _c;
    var settings = _a.settings, proposedAnchor = _a.proposedAnchor, onClose = _a.onClose, onSaved = _a.onSaved;
    var formatMessage = useIntl().formatMessage;
    var kyInstance = useOkapiKy();
    var queryClient = useQueryClient();
    var titleId = settings.titleId, titleName = settings.titleName, frequency = settings.frequency, continuousNumbering = settings.continuousNumbering, continuousNumberingAnchorVolumeLabel = settings.continuousNumberingAnchorVolumeLabel, continuousNumberingStartNumber = settings.continuousNumberingStartNumber, checkPeriodMonths = settings.checkPeriodMonths, volumeStartDay = settings.volumeStartDay, volumeStartMonth = settings.volumeStartMonth;
    var manual = isManualFrequency(frequency);
    var _d = useState(checkPeriodMonths !== null), useCustomPeriod = _d[0], setUseCustomPeriod = _d[1];
    var _e = useState(checkPeriodMonths !== null && checkPeriodMonths !== void 0 ? checkPeriodMonths : DEFAULT_MONTHS_HINT), months = _e[0], setMonths = _e[1];
    var _f = useState((_b = proposedAnchor === null || proposedAnchor === void 0 ? void 0 : proposedAnchor.day) !== null && _b !== void 0 ? _b : volumeStartDay), anchorDay = _f[0], setAnchorDay = _f[1];
    var _g = useState(String((_c = proposedAnchor === null || proposedAnchor === void 0 ? void 0 : proposedAnchor.month) !== null && _c !== void 0 ? _c : volumeStartMonth)), anchorMonth = _g[0], setAnchorMonth = _g[1];
    var _h = useState([]), collisions = _h[0], setCollisions = _h[1];
    var _j = useState(null), errorMessage = _j[0], setErrorMessage = _j[1];
    var monthOptions = useMemo(function () {
        return MONTHS.map(function (month) { return ({
            value: String(month),
            label: formatMessage({
                id: "ui-br-legaldeposits.periodicals.matrix.month.".concat(month),
            }),
        }); });
    }, [formatMessage]);
    var parsedMonth = Number(anchorMonth);
    var anchorValid = isValidVolumeAnchor(anchorDay, parsedMonth);
    var monthsValid = months >= MIN_MONTHS && months <= MAX_MONTHS;
    var settingsValid = anchorValid && (!manual || !useCustomPeriod || monthsValid);
    var checkSettingsRequest = useMemo(function () {
        var anchorChanged = anchorDay !== volumeStartDay || parsedMonth !== volumeStartMonth;
        var periodChanged = manual &&
            (useCustomPeriod
                ? months !== checkPeriodMonths
                : checkPeriodMonths !== null);
        if (!anchorChanged && !periodChanged)
            return null;
        var anchor = {
            volumeStartDay: anchorDay,
            volumeStartMonth: parsedMonth,
        };
        return manual
            ? __assign(__assign({}, anchor), { checkPeriodMonths: useCustomPeriod ? months : undefined, clearCheckPeriod: !useCustomPeriod }) : anchor;
    }, [
        anchorDay,
        parsedMonth,
        volumeStartDay,
        volumeStartMonth,
        manual,
        useCustomPeriod,
        months,
        checkPeriodMonths,
    ]);
    var numbering = useContinuousNumberingDraft(settings, settingsValid ? checkSettingsRequest : null);
    var markPlanStale = numbering.markPlanStale;
    var isValid = settingsValid && numbering.startValid;
    var invalidateViews = useCallback(function (renumbered) {
        queryClient.invalidateQueries(["periodicalCheckTasks"]);
        queryClient.invalidateQueries(["periodicalLibraries"]);
        queryClient.invalidateQueries([PERIODICAL_LIBRARY_DETAIL_KEY]);
        queryClient.invalidateQueries(["nextIssueNumber", titleId]);
        if (renumbered) {
            invalidateVolumeViews(queryClient);
            invalidateDepositRecordViews(queryClient);
        }
    }, [queryClient, titleId]);
    // One request either way: the numbering carries the changed check settings, so both commit or neither does.
    var saveMutation = useMutation(function (_a) {
        var numberingRequest = _a.numbering, checkSettings = _a.checkSettings;
        return numberingRequest
            ? applyContinuousNumbering(kyInstance, titleId, numberingRequest)
            : updatePeriodicalCheckSettings(kyInstance, titleId, checkSettings);
    }, {
        onSuccess: function (_result, _a) {
            var numberingRequest = _a.numbering;
            invalidateViews(numberingRequest !== null);
            onSaved === null || onSaved === void 0 ? void 0 : onSaved();
            onClose();
        },
        onError: function (error_1, _a) { return __awaiter(void 0, [error_1, _a], void 0, function (error, _b) {
            var found, _c, _d;
            var numberingRequest = _b.numbering;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        invalidateViews(numberingRequest !== null);
                        return [4 /*yield*/, readErrorCode(error)];
                    case 1:
                        if ((_e.sent()) ===
                            ErrorType.CONTINUOUS_NUMBERING_PLAN_STALE) {
                            setCollisions([]);
                            setErrorMessage(null);
                            markPlanStale();
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, extractNumberingCollisions(error)];
                    case 2:
                        found = _e.sent();
                        setCollisions(found);
                        _c = setErrorMessage;
                        if (!(found.length > 0)) return [3 /*break*/, 3];
                        _d = null;
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, extractServerErrorMessage(error, formatMessage, formatMessage({
                            id: "ui-br-legaldeposits.periodicalCheck.settings.saveError",
                        }))];
                    case 4:
                        _d = _e.sent();
                        _e.label = 5;
                    case 5:
                        _c.apply(void 0, [_d]);
                        return [2 /*return*/];
                }
            });
        }); },
    });
    var saveRequest = numbering.saveRequest;
    var handleSave = useCallback(function () {
        setCollisions([]);
        setErrorMessage(null);
        if (!saveRequest && !checkSettingsRequest) {
            onClose();
            return;
        }
        saveMutation.mutate({
            numbering: saveRequest,
            checkSettings: checkSettingsRequest,
        });
    }, [saveMutation, saveRequest, checkSettingsRequest, onClose]);
    var saveDisabled = !isValid || !numbering.ready || saveMutation.isLoading;
    return (React.createElement(Modal, { open: true, onClose: onClose, label: formatMessage({
            id: "ui-br-legaldeposits.periodicalCheck.settings.title",
        }), dismissible: true, footer: React.createElement(ModalFooter, null,
            React.createElement(Button, { buttonStyle: "primary", onClick: handleSave, disabled: saveDisabled }, formatMessage({
                id: numbering.renumbers
                    ? "ui-br-legaldeposits.periodicalCheck.settings.numbering.saveAndRenumber"
                    : "ui-br-legaldeposits.button.save",
            })),
            React.createElement(Button, { onClick: onClose, disabled: saveMutation.isLoading }, formatMessage({ id: "ui-br-legaldeposits.button.cancel" }))) },
        React.createElement("p", null, formatMessage({ id: "ui-br-legaldeposits.periodicalCheck.settings.intro" }, { title: titleName !== null && titleName !== void 0 ? titleName : "" })),
        React.createElement("p", null, formatMessage({ id: "ui-br-legaldeposits.periodicalCheck.settings.numberingMode" }, {
            mode: continuousNumbering &&
                continuousNumberingAnchorVolumeLabel &&
                continuousNumberingStartNumber !== null
                ? formatMessage({
                    id: "ui-br-legaldeposits.periodicalCheck.settings.numbering.modeContinuousFrom",
                }, {
                    volume: continuousNumberingAnchorVolumeLabel,
                    number: continuousNumberingStartNumber,
                })
                : formatMessage({
                    id: continuousNumbering
                        ? "ui-br-legaldeposits.periodicals.numbering.hint.continuous"
                        : "ui-br-legaldeposits.periodicals.numbering.hint.perYear",
                }),
        })),
        React.createElement("h4", { className: styles.sectionHeading }, formatMessage({
            id: "ui-br-legaldeposits.periodicalCheck.settings.volumeAnchor",
        })),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 4 },
                React.createElement(TextField, { type: "number", min: 1, max: 31, value: anchorDay, onChange: function (e) {
                        return setAnchorDay(parseInt(e.target.value, 10) || 0);
                    }, label: formatMessage({
                        id: "ui-br-legaldeposits.periodicalCheck.settings.volumeAnchorDay",
                    }), error: anchorValid
                        ? undefined
                        : formatMessage({
                            id: "ui-br-legaldeposits.periodicalCheck.settings.volumeAnchorError",
                        }), required: true })),
            React.createElement(Col, { xs: 8 },
                React.createElement(Select, { value: anchorMonth, onChange: function (e) {
                        return setAnchorMonth(e.target.value);
                    }, dataOptions: monthOptions, label: formatMessage({
                        id: "ui-br-legaldeposits.periodicalCheck.settings.volumeAnchorMonth",
                    }), required: true }))),
        React.createElement("p", { className: styles.anchorHint }, formatMessage({
            id: "ui-br-legaldeposits.periodicalCheck.settings.volumeAnchorHint",
        })),
        React.createElement(ContinuousNumberingSection, { settings: settings, draft: numbering }),
        manual ? (React.createElement(React.Fragment, null,
            React.createElement(Checkbox, { checked: useCustomPeriod, onChange: function () { return setUseCustomPeriod(function (previous) { return !previous; }); }, label: formatMessage({
                    id: "ui-br-legaldeposits.periodicalCheck.settings.customPeriod",
                }) }),
            useCustomPeriod && (React.createElement("div", { className: styles.nestedField },
                React.createElement(TextField, { type: "number", value: months, min: MIN_MONTHS, max: MAX_MONTHS, onChange: function (e) {
                        return setMonths(parseInt(e.target.value, 10) || 0);
                    }, label: formatMessage({
                        id: "ui-br-legaldeposits.periodicalCheck.settings.monthsLabel",
                    }), error: monthsValid
                        ? undefined
                        : formatMessage({
                            id: "ui-br-legaldeposits.periodicalCheck.settings.monthsError",
                        }) }))))) : (React.createElement("p", { className: styles.manualOnlyHint }, formatMessage({
            id: "ui-br-legaldeposits.periodicalCheck.settings.manualOnlyHint",
        }))),
        errorMessage && (React.createElement(MessageBanner, { type: "error" }, errorMessage)),
        collisions.length > 0 && (React.createElement("div", { className: styles.error },
            React.createElement("p", null, formatMessage({
                id: "ui-br-legaldeposits.periodicalCheck.settings.collisions",
            })),
            React.createElement("ul", null, collisions.map(function (collision) { return (React.createElement("li", { key: collision }, formatMessage({
                id: "ui-br-legaldeposits.periodicalCheck.settings.collisionItem",
            }, {
                volume: collision.split(":")[0],
                number: collision.split(":")[1],
            }))); }))))));
};
export var PeriodicalCheckSettingsDialog = function (_a) {
    var open = _a.open, rest = __rest(_a, ["open"]);
    return open ? React.createElement(PeriodicalCheckSettingsDialogBody, __assign({}, rest)) : null;
};
